import { configureStore } from "@reduxjs/toolkit";
import contactus from "../features/contact_us/Slice";


export const store = configureStore({
    reducer: {
     
        contactus: contactus,
    },
});
